import type { ReactNode } from "react";
import { Logo } from "./ui/Logo";

/** 로그인·가입·온보딩처럼 한 가지 일을 하는 화면의 가운데 정렬 틀. */
export function AuthShell({
  title,
  description,
  children,
  footer,
  wide,
  step,
}: {
  title: ReactNode;
  description?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  wide?: boolean;
  step?: { current: number; total: number; label?: string };
}) {
  return (
    <div className="flex min-h-screen flex-col">
      <header className="flex h-16 items-center px-5 sm:px-8">
        <Logo />
      </header>
      <main className="flex flex-1 justify-center px-4 pb-16 pt-4 sm:pt-10">
        <div className={`w-full animate-fade-in ${wide ? "max-w-[720px]" : "max-w-[440px]"}`}>
          {step && (
            <p className="mb-3 text-sm font-semibold text-primary-900">
              {step.current} / {step.total}
              {step.label && <span className="ml-2 font-medium text-gray-600">{step.label}</span>}
            </p>
          )}
          <h1 className="text-xl font-bold text-gray-900 sm:text-2xl">{title}</h1>
          {description && <p className="mt-2 text-base text-gray-600">{description}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-8 text-center text-sm text-gray-600">{footer}</div>}
        </div>
      </main>
    </div>
  );
}
